import { render, staticRenderFns } from "./PatternMaker.vue?vue&type=template&id=b5a0ddba"
import script from "./PatternMaker.vue?vue&type=script&lang=js"
export * from "./PatternMaker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports